import * as React from "react";
function SvgSlideshow(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M44.6 2.6H25.3V0h-2.6v2.6H3.4C1.9 2.8.8 4.1.8 5.7v25.5c0 1.3 1 2.3 2.3 2.3h41.4c1.3.1 2.4-.8 2.6-2.1V5.7c.1-1.6-1-2.9-2.5-3.1zm0 28.3H3.4V5.1h41.2v25.8zM10 27h5.9c.4 0 .8-.1 1-.4l5.4-7.5 4.5 3.7c.5.5 1.3.4 1.8-.1l8.8-9.7c.5-.5.5-1.3 0-1.8s-1.3-.5-1.8 0l-.1.1-8 8.8-4.5-3.8c-.3-.3-.6-.4-1-.3-.4 0-.6.1-.9.4l-5.8 8H10c-.8 0-1.3.5-1.3 1.3S9.2 27 10 27zM3.4 42.5h9.3l-2.4 4.4 2.3 1 3.1-5.4h16.9l3.1 5.5 2.3-1.2-2.6-4.4h9.3v-2.6H3.4v2.7z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgSlideshow);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
